import React from 'react';
import PageTemplate from './PageTemplate.js';
import Typography from '@material-ui/core/Typography';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import MatrixCard from 'matrix-card';

const downloadPageTexttheme = createMuiTheme({
	palette: {
		primary: { main: "#FFFFFF" },
		secondary: { main: "#ffe3ff" },
	},
});

const useStyles = makeStyles(theme => ({
	centerContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
}));

export default function DownloadPage() {
	const classes = useStyles();
	const l_content = <MatrixCard
		id={"my-id-2"}
		matrixText={"0123456789"}
		delay={100}
		backgroundColor={"rgba(9,9,9, 0.1)"}
		textFontSize={"16"}
		textMainColor={"#FF0000"}
		textAlternateColorRatio={0.1}
		textAlternateColorList={["#F00000", "#EA0000", "#E00000", "#D60000"]}
		styleOverrideForCanvas={{
			backgroundColor: "#FF0000",
		}}
		styleOverrideForChildrenDiv={{
			backgroundColor: "#00000000",
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		}}
		canvasSize={{ width: '480', height: '128' }}
	>
		<Grid container spacing={2} justify="center">
			<Grid item xs={12} className={classes.centerContainer}>
				<ThemeProvider theme={downloadPageTexttheme}>
					<Typography variant="h6" align="center" color="secondary" paragraph>
						{"Download & Play"}
					</Typography>
				</ThemeProvider>
			</Grid>
			<Grid item xs={12} className={classes.centerContainer}>
				<ThemeProvider theme={downloadPageTexttheme}>
					<Typography variant="h6" align="center" color="secondary" paragraph>
						{"Improve Your Skills & Have Fun"}
					</Typography>
				</ThemeProvider>
			</Grid>
		</Grid>
	</MatrixCard>;
	return <PageTemplate>{l_content}</PageTemplate>;
}
